import { Component, ViewEncapsulation } from '@angular/core';
import { Params } from '@angular/router';
import { PageComponent } from '@shared/lib/components/page.component';

@Component({
  selector: 'u-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewsListComponent extends PageComponent {
  // set to object to avoid BaseComponent default content process
  src = {};

  amountNumPrefix;
  metaPrefix;
  dataPrefix;

  map;
  pageInfo;
  navData;
  param;

  mapData = {
    totalNum: 'totalNum',
    unusedIndexes: 'unusedIndexes',
    navText1: 'navText1',
    navText2: 'navText2',
    pageText1: 'pageText1',
    pageText2: 'pageText2',
  };

  // the number of Dataes
  totalDataNum;
  // the number of each page data
  pageSize: number;
  // the maxSize of each page
  maxSize: number;
  // the size of current page
  curPage = 1;
  // the Dataes of the current page
  curDataes;
  // the index that clicked tab
  dataIndex: number;
  // the total pages
  totalPages: number;

  pageIndexes: number[] = [];

  private unusedIndexes: number[];

  private readonly unusedNewsIndexes: number[] = [39, 21, 17, 14, 19, 48];
  private readonly unusedCharityIndexes: number[] = [];
  private readonly unusedCharityNewsIndexes: number[] = [];

  // the final data and pageNum on curPage
  pageChange(pageNum: number) {
    this.curPage = pageNum;
    this.curDataes = this.getPageData(pageNum);
    window.scrollTo(0, 0);
  }

  // the Web or the mobile
  isWebOrMobile(): boolean {
    const screenWidth = document.body.clientWidth;
    return screenWidth <= 750;
  }

  // get the data number of curpage
  getPageData(page: number) {
    if (!this.isWebOrMobile()) {
      this.pageSize = 18;
      this.maxSize = 5;
    } else {
      this.pageSize = 9;
      this.maxSize = 3;
    }
    this.totalPages = Math.floor((this.totalDataNum - 1) / this.pageSize) + 1;
    this.pageIndexes = [];
    for (let i = 1; i <= this.totalPages; i++) {
      this.pageIndexes.push(i);
    }

    this.pageInfo = this.navData.pageText1 + this.totalPages + this.navData.pageText2;

    // get the data
    const dataes: any = [];
    const _dataes = this.data.items;
    if (_dataes === undefined) {
      return;
    }

    for (let i = (page - 1) * this.pageSize; i < page * this.pageSize; i++) {
      dataes.push(_dataes[i]);
      if (_dataes[i] === undefined) {
        dataes.pop(_dataes[i]);
      }
    }
    return dataes;
  }

  toDetails(page: number): void {
    this.getDataIndex(page);
    this.router.navigate(['/zhs-CN/details', this.param, this.dataIndex]);
  }

  getDataIndex(curIndex: number): number {
    this.dataIndex = curIndex;
    return this.dataIndex;
  }

  // get the items options
  private getItems(itemNum: number) {
    const items = [];
    for (let i = 0; i < itemNum; i++) {
      if (!this.unusedIndexes.includes(i)) {
        items.push({
          id: 'items.' + i + '.id',
          imgUrl: 'items.' + i + '.imgUrl',
          heading: 'items.' + i + '.heading',
          timeText: 'items.' + i + '.timeText',
          linkText: 'items.' + i + '.linkText',
        });
      }
    }
    return items;
  }

  protected defaultComponentData() {
    this.dataIsLoaded = false;
  }

  loadMeta() {
    this.translationMapperService.translateFromMap(this.metaPrefix, this.map).then((data) => {
      super.processComponentData(data);
    });
  }

  loadData() {
    this.translationMapperService.translateFromMap(this.amountNumPrefix, this.mapData).then((tData) => {
      this.navData = tData;

      if (tData.unusedIndexes) {
        const remoteUnusedIndexes = tData.unusedIndexes
          .split(',')
          .filter((v) => v.trim())
          .map((v) => parseInt(v.trim(), 10));
        this.unusedIndexes = [...new Set(this.unusedIndexes.concat(remoteUnusedIndexes))];
      }

      this.totalDataNum = tData.totalNum - this.unusedIndexes.length;

      this.map = {
        title: 'title',
        text: 'text',
        items: this.getItems(tData.totalNum).reverse(),
      };

      this.translationMapperService.translateFromMap(this.dataPrefix, this.map).then((tData2) => {
        this.data = tData2;
        this.curDataes = this.getPageData(this.curPage);
        this.dataIsLoaded = true;
      });
    });
  }

  // eslint-disable-next-line
  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.setInitialData(params);
      super.ngOnInit();
      this.curPage = 1;
      this.loadMeta();
      this.loadData();
    });
  }

  setInitialData(params: Params): void {
    this.param = params.newslist;
    if (this.param === 'press-release') {
      this.amountNumPrefix = 'page-news-list-amount';
      this.dataPrefix = 'page-news-list';
      this.metaPrefix = `page-news-list-meta`;
      this.unusedIndexes = this.unusedNewsIndexes;
    } else if (this.param === 'charity-group') {
      this.amountNumPrefix = 'page-charity-list-amount';
      this.dataPrefix = 'page-charity-list';
      this.metaPrefix = `page-charity-list-meta`;
      this.unusedIndexes = this.unusedCharityIndexes;
    } else if (this.param === 'charity-news') {
      this.amountNumPrefix = 'page-charity-news-amount';
      this.dataPrefix = 'page-charity-news';
      this.metaPrefix = `page-charity-news-meta`;
      this.unusedIndexes = this.unusedCharityNewsIndexes;
    } else {
      this.router.navigate(['/zhs-CN/falsepath']);
    }
  }
}
